const I18N_STORAGE_KEY = 'lang';

export const getLanguageFromLocalStorage = () => localStorage.getItem(I18N_STORAGE_KEY);

export const setLanguageToLocalStorage = (lng: string) => localStorage.setItem(I18N_STORAGE_KEY, lng);
